export const isWPSClient = function () {
  if (typeof window['cefQuery'] !== 'undefined') {
    return true
  } else {
    return false
  }
}

interface WPSOFFICE_API_ARGS {
  api?: string
  params: object,
}

interface CALL_CLIENT_WEBVIEW_PARAMS {
  width: number
  height: number
  startupurl: string
  isModal: boolean
}
const getCallbackFn = (function () {
  let index = 1
  return function (cb: Function, params?, isStay?) {
    const fnName = '_clientCallBack' + index++
    window[fnName] = function (result) {
      cb(result)
      !isStay && delete window[fnName]
    }
    const cbFn = params && params.callbackName
    if (cbFn) {
      const cbName = '_clientCallBack' + index++
      window[cbName] = function (result) {
        cbFn(result)
      }
      params.callbackName = cbName
    }
    return 'window.' + fnName
  }
})()

/**
 *
 * @string fnStr
 * @array argObjs [{key:xxx,value:xxx}] or {key1: value1, key2: value2}
 * @fn cb
 */
export const callWPSClientAPI = function (fnStr: string, argObjs: WPSOFFICE_API_ARGS | Array<{ key: string, value: any }>, cb?: Function, isStay?: boolean) {
  if (!isWPSClient()) return

  argObjs = argObjs || []
  const argValueArr: Array<any> = []
  const params: any = {}
  let argObj
  let key
  let value

  if (Array.isArray(argObjs)) {
    for (let i = 0; i < argObjs.length; i++) {
      argObj = argObjs[i]
      key = argObj.key
      value = argObj.value

      argValueArr.push(value)
      params[key] = value
    }
    // argObjs is Object
  } else {
    for (key in argObjs) {
      value = argObjs[key]
      argValueArr.push(value)
      params[key] = value
    }
  }

  try {
    params.method = fnStr
    if (cb) {
      const callback = getCallbackFn(cb, params.params, isStay)
      params.callback = callback
      params.params.callbackName = callback
    }
    const cefParams = {
      request: "jsAsynCall('" + JSON.stringify(params) + "')",
      persistent: false
      // onSuccess(response) {
      //   cb && cb(response)
      // },
      // onFailure(errorCode, errorMessage) {
      //   /* eslint-disable */
      //   console.log(errorCode, errorMessage);
      // },
    }
    /* eslint-disable */
    console.log("params:", params);
    /* eslint-disable */
    console.log("cefQuery: ", cefParams);
    const cefQuery = window['cefQuery']
    cefQuery(cefParams);
  } catch (e) {
    /* eslint-disable */
    console.log(e);
  }
}

interface ExecResponse {
  callstatus: string
}
export const execPromise = <T = any>(api: string, params: Record<string, any> = {}) => new Promise<ExecResponse & T>((resolve, reject) => {
  callWPSClientAPI(
    api,
    {
      params,
    },
    (res) => {
      if (!res) {
        reject('res is empty')
        return
      }
      try {
        // 修复由于客户端返回的字符串带 \ 被识别为转义符，导致序列化失败
        res = res.replace(/\\/g, '\\\\')
        res = res.replace(/\\\\\\\\/g, '\\\\')

        const data = JSON.parse(res)
        if (data.callstatus == 'ok') {
          resolve(data)
          return
        }
        reject(data.callstatus)
      } catch (e) {
        reject(e)
      }
    }
  );
})
